import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";

// Antes este hook generaba las clases del diálogo con makeStyles de @mui/styles (5.12.3),
// que lee el theme del contexto de @mui/private-theming v5. Pero el ThemeProvider de la app
// (JumboTheme.js) es el de @mui/material 6.4.2, que escribe en el contexto v6: son módulos
// distintos, o sea contextos de React distintos. useTheme() devolvía null, makeStyles caía
// a su noopTheme (un objeto vacío) y style.js reventaba en theme.palette.text.primary.
//
// Resultado: TypeError en el render y PÁGINA EN BLANCO en toda vista que llamara a este hook
// (auth/reset-password, home/Logs, home/Customers).
//
// sweetalert2 v11 inyecta sus propios estilos, así que no necesitamos JSS para nada.
const useSwalWrapper = () => withReactContent(Swal);

export default useSwalWrapper;
